module.exports = __webpack_public_path__ + "img/fi-rr-file-ai.acef1bb5.svg";